import React, { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import {
  Form,
  Container,
  Row,
  Modal,
  Toast,
  Card,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import "./detailNew.css";
import ConfirmationModal from "./ConfirmationModal";
import HSNModal from "./HSNModal";
import { useAlert } from "react-alert";
import "../../assets/css/Offcanvas.css";
import "./popup.css";
import Confirmation from "./Confirmation";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProductDetailSingle,
  newPriceReqSingle,
  updateOfferPriceReqSingle,
  updateProductGSTSingle,
  updateProductStatusSingle,
  verifyTransferPriceSingle,
} from "../../Actions/ProductDetail/Single";
import "../../assets/css/productDetail.css";
import api from "../../seller-apis/api";
import PopupProductReport from "./PopupProductReport";
import TPriceHistoryModal from "./TPriceHistoryModal";
import QuestionAnsList from "./QuestionAnsList";
import ProductReviews from "./ProductReviews";
import WeightComponent from "./WeightComponent";
import { resetPackages, setInitialPackages, setReferencePackage, setEditBtn } from "../../Actions/PackageWeight";
import { ftToCm, packagesCmtoFt, packagesFttoCm } from "../../utilities/conversion";
import { variables } from "../../Variables.json"
import { arePackagesEqual, checkIsPkgMediaNotPresent, isPackageLocked, sanitizePkgImages } from "../../utilities/packages";
import { formatedDate, toLocalDateTime } from "../../utilities/ConvertDateFormat";
import { saveVendorStock } from "../../services/vendor.service";
import moment from 'moment';
import { Actions } from "../../Actions/Actions";
import { fetchAllNotifications } from "../../seller-apis/apidataField";
import PackageHistoryModal from "./PackageHistoryModal";

function ProductDetail(props) {
  let alert = useAlert();


  const [check, setChecked] = useState(true);
  const [inActiveCheck, setinActiveCheck] = useState(false);

  // HSN Modal States
  const [showHSNModal, setShowHSNModal] = useState(false);

  // Confirmation Related States
  const [confirmationShow, setconfirmationShow] = useState(false);
  const [confirmationState, setconfirmationState] = useState(false);
  const [buttonDesign, setButtonDesign] = useState(false);
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [selectedId, setselectedId] = useState();
  const [activDeactiveState, setactivDeactiveState] = useState();
  const [deactiveReason, setdeactiveReason] = useState(false);
  const [paginationIndex, setPaginationIndex] = useState(0);

  // Toast

  const [showToast, setshowToast] = useState(false);
  const [ToastMsg, setToastMsg] = useState();

  // Popup related states

  const [updtProVisibility, setupdtProVisibility] = useState(false);

  //  Offcanvas

  const [offcanshow, setoffcanshow] = useState(false);
  const [offcanstate, setoffcanstate] = useState("askNewPrice");
  const [newPrice, setnewPrice] = useState("-1");
  const [seloption, setseloption] = useState("continueSame");

  // Offcanvas for verify transfer price

  const [offcanshowverify, setoffcanshowverify] = useState(false);
  const [offcanstateverify, setoffcanstateverify] = useState("ask");

  // Offcanvas for showing transfer price history

  const [offcanshowpriceHist, setoffcanshowpriceHist] = useState(false);

  // Image modal

  const [imgmodalShow, setimgmodalShow] = useState(false);

  const [gstPercent, setGstPercent] = useState();
  const [gstOptions, setGstOptions] = useState(variables?.gstValues);
  const state = useSelector((state) => state.productDetailSingleReducer);
  const { packages, intitialPackages, dimensionUnit } = useSelector((state) => state.packageReducer);
  const dispatch = useDispatch();
  const [mainImg, setMainImg] = useState(state.mainImg);
  const [mainVideo, setMainVideo] = useState("");
  const [videosrc, setVideoSrc] = useState(state?.videos.length > 0 ? state?.videos[0] : null);
  const [pkgs, setPkgs] = useState([]);


  const [showMoreDetails, setshowMoreDetails] = useState(false);
  const monthAbbreviations = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const [isDetailPopupVis, setisDetailPopupVis] = useState("none");

  const [pkgsValidation, setPkgsValidation] = useState(0);
  const [pkgChanged, setPkgChanged] = useState(false);
  const [showWeightSubmitBtn, setShowWeightSubmitBtn] = useState(false);
  const [isPackageUpdated, setIsPackageUpdated] = useState(false);

  //SL-699 Seller Stock
  const [stockEdit, setStockEdit] = useState(false);
  const [inputStockValue, setInputStockValue] = useState(state.pVend?.stock || 0);
  const [notificationData, setNotificationData] = useState({});

  // l1-2553
  const [pkgHistoryModalShow, setPkgHistoryModalShow] = useState(false);



  useEffect(() => {
    let catList = [];
    let catname;

    // Fetch product detail
    setGstPercent(state.currGst);
    let data = {
      pId: props.match.params.pId,
    };
    setselectedId(props.match.params.pId);
    fetchProductDetailSingle(dispatch, data);
  }, []);


  useEffect(() => {
    setMainImg(state.mainImg);
  }, [state.mainImg]);
  useEffect(() => {
    setVideoSrc(state?.videos.length > 0 ? state?.videos[0] : null);
  }, [state.mainImg]);

  useEffect(() => {
    setMainVideo(state.mainVideo);
  }, [state.productDetailSingleReducer]);

  useEffect(() => {
    let propPkgs = [];
    if (state.pkgs && state.pkgs.length > 0) {
      for (const pkg of state.pkgs) {
        if (pkg.status == "APPROVED") {
          pkg["packageWidthFront"] = (pkg.packageWidth / 30.48).toFixed(2);
          pkg["packageHeightFront"] = (pkg.packageHeight / 30.48).toFixed(2);
          pkg["packageLengthFront"] = (pkg.packageLength / 30.48).toFixed(2);
          propPkgs.push(pkg);
        }
      }
    }
    setPkgs(propPkgs);
    if (state?.pVend?.sellerWeightChangeSts === "T_PENDING") {
      api.product.getSellerWeightChangePendingReq({ product: props.match.params.pId }).then((res) => {
        dispatch(setInitialPackages(packagesCmtoFt(res?.data?.pkgs)))
      })
    }
    else {
      if (!state?.pDetail?.isDefaultPkg) {
        dispatch(setInitialPackages(packagesCmtoFt(state?.pkgs)))
        dispatch(setEditBtn(checkIsPkgMediaNotPresent(state?.pkgs)))
      }
      else {
        dispatch(resetPackages())
      }
    }
  }, [state.pkgs]);

  useEffect(() => {
    dispatch(setReferencePackage(packagesCmtoFt(state?.pDetail?.lowestPkgs)))
  }, [state.pDetail.pkgs])

  useEffect(() => {
    // make notification opened true
    const vndActData = {
      "filter": {
        "product-objectId": props.match.params.pId
      }
    }
    api.notify
      .updateVendorActLogs(vndActData)
      .then((res) => {

      })
      .catch((err) => {
        console.log(err);

      });
  }, [props.match.params.pId]);

  // Deactivate product
  function changeToggle() {
    setdeactiveReason(true);
    setactivDeactiveState("deactivate");
    setmsgConfirmation(
      `Are you sure you want to make this product "Out of Stock" ?`
    );
    setButtonDesign(true);
    setconfirmationState(true);
  }

  // Activate product
  function changeinActivetoggle() {
    setdeactiveReason(false);
    setactivDeactiveState("activate");
    setmsgConfirmation(
      `Are you sure you want to make this product "In Stock" ?`
    );
    setconfirmationState(true);
  }

  // l1-2319 (2-9-25)

  // HSN Modal Handlers
  const handleHSNEdit = () => {
    setShowHSNModal(true);
  };

  const handleHSNModalClose = () => {
    setShowHSNModal(false);
  };


  const handleHSNSave = async ({ productId, hsnCode, gstRate }) => {
    let data = {
      _id: productId,
      HSN: hsnCode,
      taxClass: gstRate
    }
    try {
      let res = await api.product.addToExProduct(data)
      if (res.message === "product updated" || res.message === "product added") {
        alert.success("Product updated Successfully!");
        fetchProductDetailSingle(dispatch, { pId: selectedId });
      }
      else {
        alert.info(res.message);
      }
    }
    catch (err) {
      alert.info("Failed to update HSN");
      console.log(err);
    }
    finally {
      handleHSNModalClose();
    }
  }

  // Confirmation Modal
  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false);
      setButtonDesign(false);
    }
  }

  // update seller weight change sts
  const updateSellerWeightChangeSts = async (status) => {
  let data = {
    product: selectedId,
    sellerWeightChangeSts: status,
  };
  try {
    const res = await api.product.sellerWeightChangeStsUpdate(data);
    let data1 = {
      pId: selectedId,
    };
    fetchProductDetailSingle(dispatch, data1);
    alert.success("Details updated");

    // Close the weight notification after accepting
    await closeNotificationAndRefresh('weight');
  } catch (err) {
    alert.error("Failed to update");
  }
};

  // Response Confirmation

  async function responseconfirmation(ans, productId, stock, reason) {

    setconfirmationState(false);
    if (ans === "yes") {
      // apprscrollLen = 1;
      if (activDeactiveState === "activate") {
        let data;
        data = {
          _id: productId,
          vActive: "ACTIVE",
        };
        //SL-702 / SL-699
        if (stock && stock != null && stock != undefined)
          data["stock"] = stock;

        // l1-2341 (9-9-25)
        await handleSaveVendorStock("In Stock", stock);
        updateProductStatusSingle(dispatch, data);
      } else if (activDeactiveState === "deactivate") {
        let data;
        data = {
          _id: productId,
          vActive: "INACTIVE",
          reason: reason,

        };
        setInputStockValue(0);
        // l1-2341 (9-9-25)
        await handleSaveVendorStock("Out Of Stock", 0);
        updateProductStatusSingle(dispatch, data);
      }
    }
  }

  // l1-2341 (9-9-25)
  const handleSaveVendorStock = async (stockStatus, stockVal) => {
    try {
      let data = {
        "product": state?.pDetail?._id,
        "vendor": state?.pDetail?.vendors?.[0]?.vendor_id,
        "taxClass": state?.pDetail?.vendors?.[0]?.taxClass,
        "purchase_price": state?.pDetail?.vendors?.[0]?.purchase_price,
        "stock": stockVal,
        "status": "AUTOAPPROVED",
        "stockStatus": stockStatus,
        "site_price": state?.pDetail?.specialPrice ? state?.pDetail?.specialPrice : state?.pDetail?.price,
        "categories": state?.pDetail?.categories,
        "receivedFrom":"seller"
      }
      const res = await saveVendorStock(data)
    } catch (err) {
      console.log(err)
      alert.error(err.message || "Failed to update stock status");
      // Re-throw the error so the calling function knows it failed
      throw err;
    }
  }

  // Inactive request click
  const handleToast = () => {
    setToastMsg("Inactive request already sent to Toolsvilla");
    setshowToast(true);
  };

  // Offcanvas show/hide
  const handleCloseoffcan = () => {
    setnewPrice();
    setoffcanshow(false);
    setoffcanstate("askNewPrice");
    setseloption("");
  };
  const handleCloseoffcanverify = () => {
    setnewPrice();
    setoffcanshowverify(false);
    setoffcanstateverify("ask");
  };
  const handleopenoffcan = () => setoffcanshow(true);
  const handleopenoffcanverify = () => setoffcanshowverify(true);
  const handleopenoffcanpriceHist = () => setoffcanshowpriceHist(true);
  const handleCloseoffcanpriceHist = () => setoffcanshowpriceHist(false);

  // Check price

  function checkenterprice(e) {

    setnewPrice(e);
  }

  // New price request fun offcanvas 2 state

  const newPriceReq = () => {
    if (
      newPrice === undefined ||
      newPrice === "" ||
      newPrice < 1 ||
      newPrice.includes(".")
    ) {
      alert.info("Please enter a valid new price.");
    } else {
      document.getElementById("sub_newreq").disabled = true;
      let data = {
        product: selectedId,
        price: newPrice,
        // SL-1035
        receivedFrom:"Product Detail Page"
      };
      newPriceReqSingle(dispatch, data);

      if (state.pPrice < newPrice) {
        alert.show("Price request submitted", {
          type: "success",
        });
      }

      if (state.pStatus === "INACTIVE") {
        changeinActivetoggle();
      }
      handleCloseoffcanverify();
      handleCloseoffcan();
    }
    document.getElementById("sub_newreq").disabled = false;
  };

  function checkMinusInput(e) {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  }

  function showPkgEdit() {
    const nextPkgs = [...pkgs];
    nextPkgs.map((pkg, index) => {
      pkg.pkgEdit = !pkg.pkgEdit;
    });
    setPkgs(nextPkgs);
  }
  function handlePkgChange(pkgId, key, value) {

    const nextPkgs = [...pkgs];
    const pkg = nextPkgs.find((a) => a._id === pkgId);
    if (!value || value <= 0) {

      const pkgVal = pkgsValidation + 1;
      setPkgsValidation(pkgVal);
      pkg[key] = value;
      if (key == "packageWidth") {
        pkg["packageWidthFront"] = value;
      } else if (key == "packageHeight") {
        pkg["packageHeightFront"] = value;
      } else if (key == "packageLength") {
        pkg["packageLengthFront"] = value;
      }
    } else {
      const pkgVal = pkgsValidation - 1;
      setPkgsValidation(pkgVal);
      if (
        key == "packageWidth" ||
        key == "packageHeight" ||
        key == "packageLength"
      ) {
        pkg[key] = (value * 30.48).toFixed(2);
        if (key == "packageWidth") {
          pkg["packageWidthFront"] = value;
        } else if (key == "packageHeight") {
          pkg["packageHeightFront"] = value;
        } else {
          pkg["packageLengthFront"] = value;
        }

        pkg.vWeight =
          (pkg.packageWidth * pkg.packageLength * pkg.packageHeight) / 5000;
        pkg.vWeight = pkg.vWeight.toFixed(2);
      } else {
        pkg[key] = value;
      }
    }
    setPkgs(nextPkgs);
    setPkgChanged(true);
  }

  // Image modal

  const imgmodalhandleClose = () => setimgmodalShow(false);
  const imgmodalhandleShow = () => setimgmodalShow(true);

  // Accept or reject transfer price

  async function priceReqfromTool(spcl) {
  try {
    const priceNotificationData = {
      combinationUrl: state.vendToolHistArr[0]?.combinationUrl,
      source: state.vendToolHistArr[0]?.source || 'notification',
      vpriceReqId: state.vendToolHistArr[0]?._id
    };
    
    if (spcl === "reject") {
      // Close notification on reject
      await closeNotificationAndRefresh('price', priceNotificationData);
      handleopenoffcan();
    } else {
      // Accept the price
      let data = {
        product: selectedId,
        _id: state.vendToolHistArr[0]._id,
        status: "V_ACTIVE",
        price: state.offerprice,
      };
      
      await updateOfferPriceReqSingle(dispatch, data);
      
      // Close notification on accept
      await closeNotificationAndRefresh('price', priceNotificationData);
      
      if (state.pStatus === "INACTIVE") {
        changeinActivetoggle();
      }
    }
  } catch (error) {
    console.error('Error handling price request:', error);
    alert.error('Failed to process price request');
  }
}

  // Verify transfer price after 1 popup

  function noVerifyPrice() {
    setoffcanstateverify("askNewPrice");
  }

  function yesVerifyPrice() {
    if (!state.pVend.prSts) {
      let d = {
        _id: selectedId,
        purchase_price: state.pPrice,
        prSts: "V_ACTIVE",
      };
      let data = {
        data: d,
        spcl: "addToEx",
      };


      verifyTransferPriceSingle(dispatch, data);
      if (state.pStatus === "INACTIVE") {
        changeinActivetoggle();
      }
    } else {
      let d = {
        product: selectedId,
        purchase_price: state.pPrice,
        status: "V_ACTIVE",
      };
      let data = {
        data: d,
        spcl: "update",
      };
      verifyTransferPriceSingle(dispatch, data);
      if (state.pStatus === "INACTIVE") {
        changeinActivetoggle();
      }
    }
    handleCloseoffcanverify();
    handleCloseoffcan();
  }

  // Function to close all popups opened

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key === "Esc" || evt.key === "Escape") {
      setupdtProVisibility(false);
      handleCloseoffcan();
      handleCloseoffcanpriceHist();
      handleCloseoffcanverify();
    }
  };


  // Confirmation

  function responseconfirmationonly(ans) {
    if (ans) {
      changeGST();
    }
  }

  // Change GST %

  async function changeGSTFun() {
    if (gstPercent == state.currGst) {
      alert.info("Default Gst");
    } else {
      setmsgConfirmation(
        "Are you sure you want to change GST % to " + gstPercent + "% ?"
      );
      setconfirmationShow(true);
    }
  }

  function changeGST() {
    let data = {
      _id: selectedId,
      taxClass: gstPercent,
    };
    updateProductGSTSingle(dispatch, data);
    setconfirmationShow(false);
  }

  const openReportPopup = () => {

    setisDetailPopupVis("block");
  }
  function setpopupVisibilityDetail() {
    setisDetailPopupVis("none");
  }

  useEffect(() => {
    if (state.msg && state.msg.text !== undefined && state.msg.text !== "Price request submitted") {

      alert.show(state.msg.text, {
        type: state.msg.type,
      });
    }
  }, [state.msg]);

  useEffect(() => {
    setGstPercent(state.currGst);
  }, [state.currGst]);

  function scroll(spcl) {
    var doc = document.getElementById("pd_img_list_box_cntn_id");
    if (spcl === "l") {
      doc.scrollLeft -= 200;
    } else {
      doc.scrollLeft += 200;
    }
  }
  function changeImage(item, index) {
    let baseImg;
    if (item.image.startsWith("products")) {
      baseImg = item.image;
    } else if (item.image.startsWith("mob")) {
      baseImg = item.image;
    } else {
      let img = item.image.substr("41");
      baseImg = img;
    }
    setMainImg(baseImg);
    setPaginationIndex(index);
  }
  //SL-699
  const styles = {
    container: {
      stock: {
        marginTop: "10px"
      }
    },
    text: {
      currentStock: {
        position: "absolute",
        top: "-7px",
        left: "18px",
        background: "white",
        padding: "0px 5px",
        fontSize: "11px"
      }
    },
    icon: {
      wrapper: {
        position: "relative",
        display: "inline-block",
        width: "20px", // Ensures consistent space for the icon
        height: "20px", // Ensures consistent space for the icon
        paddingRight: "5px"
      },
      editStock: {
        position: "relative",
        top: "-4px",
        left: "-19px",
        fontSize: "15px",
      },
      saveImg: {
        position: "relative",
        top: "-4px",
        left: "-22px"
      }
    },
    input: {
      stock: {
        padding: "9px 22px 2px 11px",
        width: "150px"
      }
    }
  }

  //SL-699 and SL-702
  useEffect(() => {
    if (state.pVend?.stock !== undefined) {
      setInputStockValue(state.pVend.stock);
    }
  }, [state.pVend?.stock]); // Update only when state.pVend.stock changes
  /**
   * SL - 699
   * Handle Stock Change
   * @param {*} id 
   * @param {*} value 
   */
  const handleStockChange = (stockValue) => {
    //Only allow numeric values
    if (/^\d*$/.test(stockValue))
      setInputStockValue(stockValue);
  };
  /**
   * Handle Edit Click
   * @param {*} id 
   */
  const handleStockEditClick = (value) => {
    setStockEdit(value); // Set the editable row
    //setInputStockValue(stockValue); // Reset to the original value when editing starts
  };
  /**
   * Handle Save Click
   */
  const handleStockSaveClick = () => {

    // Validation: Ensure the input is a positive number or zero
    if (isNaN(inputStockValue)) {
      alert.error("Please enter a valid number.");
      return;
    }
    const stock = Number(inputStockValue);
    if (stock < 0) {
      alert.error("Please enter a valid positive number.");
      return;
    }
    updateSellerStock(selectedId, stock)// Save changes and make the input box non-editable
  };

  //Sl-699 : Seller Stock Update
  async function updateSellerStock(id, stock) {
    let data = {
      "_id": id,
      "stock": stock,
      "vActive": "ACTIVE",
      "reason": ""
    }
    //if given 0, then out of stock
    if (stock == 0)
      data["vActive"] = "INACTIVE";

    try {
      // l1-2341
      if ((Number(state?.pVend?.stock) || 0) < 1 && stock > 0) {
        await handleSaveVendorStock("In Stock", stock)
      }
      else if (Number(stock) === 0) {
        await handleSaveVendorStock("Out Of Stock", stock)
      }

      // Only call addToExProduct if saveVendorStock succeeded
      api.product.addToExProduct(data)
        .then((res) => {
          let data1 = {
            pId: selectedId,
          };
          fetchProductDetailSingle(dispatch, data1);
          alert.success("Stock Updated Successfully!")
          setStockEdit(false); 
        }).catch(err => console.log(err))
    } catch (err) {
      // If saveVendorStock failed, don't call addToExProduct
      console.log("Stock update aborted due to vendor stock error:", err)
    }

  }


  // sl-712
  const handlePackageSubmission = async () => {
    try {
      if (arePackagesEqual(packages, intitialPackages)) {
        await updateSellerWeightChangeSts("V_ACTIVE");
        return;
      }
      if (isPackageLocked(state?.pVend?.sellerWeightChangeSts) && checkIsPkgMediaNotPresent(packages)) {
        alert.error("Please upload images for package(s) before submitting.");
        return;
      }
      let pkgData;
      pkgData = {
        product: selectedId,
        status: "T_PENDING",
        pkg: { productName: state.pDetail.productName, pkgs: dimensionUnit === "cm" ? packages : packagesFttoCm(packages) },
        categories: state.pDetail.categories,
        requestType: "EXISTING_PRODUCT"
      };
      const sanitizedPkgData = sanitizePkgImages(pkgData);
      await api.product.saveSellerWeightChangeReq(sanitizedPkgData);
      let data1 = {
        pId: selectedId,
      };
      fetchProductDetailSingle(dispatch, data1);
      setShowWeightSubmitBtn(false);
      showPkgEdit();
      alert.success("Details updated");
      setIsPackageUpdated(true);
    } catch (err) {
      alert.error("error")
    }
  }

  // NEW FUNCTION: Close notification and refresh vendor activity log
const closeNotificationAndRefresh = async (notificationType, customNotificationData = null) => {
  try {
    const vendorId = localStorage.getItem('vendorId');
    
    if (notificationType === 'price') {
      const priceData = customNotificationData || notificationData;
      
      await api.notify.closeVendorPriceNotification({
        productId: String(selectedId),
        vendorId: String(vendorId),
        combinationUrl: priceData?.combinationUrl,
        source: priceData?.source || 'notification',
        vpriceReqId: priceData?.vpriceReqId ? String(priceData.vpriceReqId) : undefined,
      });
    } else if (notificationType === 'weight') {
      await api.notify.closeVendorWeightNotification(
        String(selectedId), 
        String(vendorId)
      );
    }

    await api.notify.updateVendorActLogs({
      filter: {
        "product-objectId": selectedId
      }
    });

    const dateFromWeb = moment().subtract(15, 'days').format('YYYY-MM-DD');
    const dateToWeb = moment().format('YYYY-MM-DD');
    
    // const countData = {
    //   pageNo: 1,
    //   size: 1,
    //   filters: {
    //     type: { $in: ["PRC_CHANGED"] },
    //     opened: false,
    //     "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
    //     "to-createdAt": dateToWeb + 'T23:59:59.000Z'
    //   },
    // };
    
    // const res = await api.notify.fetchNotifications(fetchAllNotifications(countData));
    // Actions.updateNotificationCount(dispatch, res.totalRecords);

  } catch (error) {
    console.error('Error closing notification:', error);
  }
};

// Handle package rejection with notification closing
const handleRejectPackage = async (status) => {
  let data = {
    product: selectedId,
    sellerWeightChangeSts: status, // "V_REJECT"
  };
  
  try {
    let data1 = {
      pId: selectedId,
    };
    const res = await api.product.sellerWeightChangeStsUpdate(data) 
    fetchProductDetailSingle(dispatch, data1);
    alert.success("Package request rejected");

    await closeNotificationAndRefresh('weight');
    
  } catch (err) {
    alert.error("Failed to reject package request");
  }
};


  if (state.isLoading) {
    return <>Loading...</>;
  } else {
    return (
      <div className="detail-new mb-4">
        <div className="pd-conf-layout">
          <div className="pd-conf-media-col">
            <div className="container">
              <div className="pd_img_main_box">
                {state.images && state.images.length > 0 ? (
                  <><img
                    src={"https://s3.toolsvilla.com/" + mainImg}
                    className=""
                    alt="img" />
                    <div className="pagination-dot-container">
                      {state.images.map((item, index) => {
                        return <div onClick={() => { changeImage(item, index) }} className={`pagination-dot ${paginationIndex == index ? "active" : ""}`}></div>;

                      })}
                    </div></>
                ) : (
                  <></>
                )}
              </div>
              <div className="image-thumbnail-slider my-4">
                {state.images && state.images.length > 3 ? (

                  <img src="/left-slide-icon.webp" className="slider-icon" alt="icon" onClick={() => scroll("l")} />
                ) : (
                  <></>
                )}
                <div
                  className="pd_img_list_box_cntn"
                  id="pd_img_list_box_cntn_id"
                >
                  {state.images.map((item, index) => {

                    return (
                      <div
                        className={`pd_img_list_box ${paginationIndex == index ? "active" : ""}`}
                        role="button"
                        onClick={() => { changeImage(item, index) }}
                      >
                        <img
                          className=""
                          src={
                            "https://s3.toolsvilla.com/" + item.image
                          }
                          alt="Product Img"
                        />
                      </div>
                    );
                  })}
                </div>
                {state.images && state.images.length > 3 ? (
                  <img src="/right-slide-icon.webp" className="slider-icon" alt="icon" onClick={() => scroll("r")} />
                ) : (
                  <></>
                )}
              </div>
              {/* Videos */}
              {/* videosrc, setVideoSrc */}
              {state.videos.length > 0 ?
                <>
                  <div className="pd_video_main_box mt-3">
                    {videosrc?.includes("products") ?
                      <video
                        controls
                        className=""
                        src={"https://media.toolsvilla.com/" + videosrc}
                        alt="Product Img"
                      />
                      :
                      <video
                        controls
                        className=""
                        src={"https://www.youtube.com/embed/" + videosrc}
                        alt="Product Img"
                      />}
                  </div>

                </> : ""
              }
              {state.videos.length > 0 ?
                <div className="video-thumbnail">
                  {
                    state.videos.map((item, index) => {
                      return <img onClick={() => setVideoSrc(item)} className={state.videos.indexOf(videosrc) == index ? "active" : ""} src="/video-thumb.webp" alt="thumbnail" />
                    })
                  }
                </div> : <></>
              }

            </div>
          </div>
          <div className="pd-conf-content-col">
            <Row className=" ">
              <Row className="mb-2">
                <div className="col-12 pr-0">
                  <span className="pd_category_label">Category</span> :{" "}
                  <span className="pd_category_name">{state.categoryName}</span>
                  <div className="mt-1">
                    <span className="pd_pName">
                      {state.pDetail.productName}
                    </span>
                  </div>
                  <div className="product-information">
                    <div>
                      <div className="sku-data mt-2">
                        <span className="">SKU</span> :{" "}
                        <span className="">
                          {state.pDetail.SKU}
                        </span>
                      </div>
                      <div className="sku-data mt-2">
                        <span className="">HSN</span> :{" "}
                        <span className="">
                          {state.pDetail.vendors?.[0]?.HSN || 'Not Available'}
                        </span>
                        <img src="/edit-icon.webp" onClick={handleHSNEdit} className="pd_change_Price_pencil ms-2" />
                      </div>
                      <span className="pd_category_label">Price : </span>
                      <span className="pd_Price_Value">
                        <i className="fa fa-inr" aria-hidden="true"></i>{" "}
                        {parseInt(state.pPrice)}
                      </span>
                      {state.pVend.prSts && state.vendToolHistArr.length > 0 ? (

                        <img src="/info-icon.webp" onClick={() => handleopenoffcanpriceHist()} className="vendor-his-icon" />
                      ) : (
                        <></>
                      )}
                      {state.pVend.prSts === "V_ACTIVE" ||
                        state.pVend.prSts === "V_REJECT" ||
                        state.pVend.prSts === "T_ACTIVE" ||
                        state.pVend.prSts === "T_REJECT" ? (
                        <>
                          {!state.pVend.saleDiscount && 
                            <img src="/edit-icon.webp" onClick={() => handleopenoffcan()} className="pd_change_Price_pencil" />
                          }
                        </>
                      ) : (
                        <></>
                      )}

                      <br></br>
                      <span className="pd_category_label">
                        Transfer Price
                      </span>{" "}
                      <span className="pd_category_name">
                        (incl. {state.currGst}% GST)
                      </span>
                      {state.lowestPrice !== undefined ? (
                        <div className="other_seller_price">
                          {"("}<span className="">
                            Other seller's price :{" "}
                          </span>
                          <span className="">
                            <i className="fa fa-inr" aria-hidden="true"></i>{" "}
                            {/*SL-958 Lowest Price */}
                            {/*state.lowestPriceMargin ? state.lowestPriceMargin : state.lowestPrice*/}
                            {state.lowestPrice}
                          </span>{")"}
                        </div>
                      ) : (
                        <></>
                      )}


                      {state.pStatus === "ACTIVE" ? (
                        <>
                          <div>
                            <div class="form-check  form-switch p-0">
                              <label class="switch-button">
                                <input type="checkbox" onClick={() => setButtonDesign(true)} onChange={() => changeToggle(props.lead)}
                                  checked={check} />
                                <span class="slider round">
                                  <span class="off">Out of Stock</span>
                                  <span class="on">In Stock</span>
                                </span>
                              </label>
                            </div>
                          </div>
                        </>
                      ) : state.pStatus === "INACTIVE" ? (
                        <>
                          <div>
                            <div class="form-check form-switch p-0">
                              <label class="switch-button">
                                <input type="checkbox" onChange={() => changeinActivetoggle(props.lead)}
                                  checked={inActiveCheck} />
                                <span class="slider round">
                                  <span class="off">Out of Stock</span>
                                  <span class="on">In Stock</span>
                                </span>
                              </label>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <div class="form-check form-switch p-0">
                              <label class="switch-button">
                                <input type="checkbox" onChange={() => handleToast()}
                                  checked={check} />
                                <span class="slider round">
                                  <span class="off">Out of Stock</span>
                                  <span class="on">In Stock</span>
                                </span>
                              </label>
                            </div>
                          </div>
                          {state.pStatus === "INACTIVE_REQ" ? (
                            <div className="">
                              <p className="inactiveReq">
                                (Inactive request pending for Toolsvilla approval)
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {/* SL-699 and SL-702 Seller Stock */}
                  <div className="row" style={styles.container.stock}>
                    <div className="col-7">
                      <span style={styles.text.currentStock}>Current Stock</span>
                      <input
                        type="number"
                        value={inputStockValue}
                        onChange={(e) => {
                          if (stockEdit)
                            handleStockChange(e.target.value);

                        }}
                        disabled={!stockEdit}
                        style={styles.input.stock}
                        onWheel={(e) => e.target.blur()}

                      />
                      <div style={styles.icon.wrapper}>
                        {stockEdit
                          ? (
                            <img
                              src='/save.png'
                              style={styles.icon.saveImg}
                              onClick={handleStockSaveClick}
                            />)
                          :
                          (<i className="bi bi-pencil"
                            style={styles.icon.editStock}
                            onClick={() => handleStockEditClick(true)}></i>)

                        }
                      </div>

                    </div>
                     <div className="col-5 d-flex justify-content-center btn_cntn_chn">
                  {!state.pVend.prSts ? (
                    <button
                      className="v-t-f"
                      onClick={() => handleopenoffcanverify()}
                    >
                      Verify transfer price
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
                  </div>
                  {state.pVend.prSts === "V_PENDING" &&
                    state.vendToolHistArr.length > 0 ? (
                    <>
                      <div className="acc_rej_cntn w-50 mx-2 mt-2">
                        <div className="mt-8 new-tr-pr-title">
                          New Transfer Price request from Toolsvilla :{" "}

                          <strong className="f-600">
                            <i className="fa fa-inr"></i> {state.offerprice}
                          </strong>
                          <br></br>
                          <span className="">
                            Do you Want to accept it ?
                          </span>
                        </div>
                        <Row className="text-center bottom-action mx-3">
                          <div className="action-button">
                            <button
                              className="no-button"
                              onClick={() => priceReqfromTool("reject")}
                            >
                              No
                            </button>
                            <button
                              className="yes-button"
                              onClick={() => priceReqfromTool("accept")}
                            >
                              yes
                            </button>
                          </div>
                        </Row>
                      </div>
                    </>
                  ) : (
                    <>

                    </>
                  )}
                </div>
              </Row>

              <Row>
                <div className="col-12">
                  {state.pVend &&
                    state.pVend.prSts &&
                    state.pVend.prSts === "T_PENDING" ? (
                    <>
                      <span className="inactiveReq fs-12 f-600 text-danger">
                        Your requested price : Rs.{" "}
                        {state.vendToolHistArr &&
                          state.vendToolHistArr.length > 0 &&
                          state.vendToolHistArr[0].price}{" "}
                        (pending for verification from Toolsvilla)
                      </span>

                      <br></br>
                    </>
                  ) : (
                    <></>
                  )}
                  {state.pVend &&
                    state.pVend.prSts &&
                    state.pVend.prSts === "T_PENDING" &&
                    state.pStatus !== "INACTIVE" ? (
                    <span className=" fs-10 f-400">
                      You agree to keep selling at the present price until the
                      transfer price is confirmed.{" "}
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
               
              </Row>
              <div className="text-center "></div>
              <div>
                <button
                  className="productissuebut"
                  onClick={() => openReportPopup()}
                >
                  <img src={'/report-product.webp'} style={{ width: '12%' }} /> Report wrong listing
                </button>
              </div>

              <div className="">
                <div className="prod-pkg-details">
                  <div className="title">Package Details</div>
                  <>
                    <div style={{ width: "93%" }}>
                      <WeightComponent
                        handleSubmit={handlePackageSubmission}
                        isUpdated={isPackageUpdated}
                        viewOnly={state?.pVend?.sellerWeightChangeSts === "T_PENDING" || state?.pVend?.sellerWeightChangeSts === "T_ACTIVE" || state?.pVend?.sellerWeightChangeSts === "V_ACTIVE" ? true : false}
                        weightRequest={state.pVend.sellerWeightChangeSts === "V_PENDING" ? true : false}
                        handleAcceptPackage={updateSellerWeightChangeSts}
                        handleRejectPackage={handleRejectPackage}  // ADD THIS LINE
                        weightChangeStatus={state.pVend.sellerWeightChangeSts}
                      />
                    </div>
                    {state.pVend.sellerWeightChangeSts === "T_REJECT" ? <span className="text-danger">The dimension request has been rejected.Please update again. 
                      {state.pVend?.sellerWeightRejectionReason ?<OverlayTrigger
                        key="transfer"
                        placement="bottom"
                        overlay={
                          <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                            <p className='fs-11 f-500 order_page_tooltip_1'>{state.pVend.sellerWeightRejectionReason}</p>
                          </Tooltip>
                        }
                      >
                        <i className="bi bi-info-circle ml-1"></i>
                      </OverlayTrigger>
                      : <></>}
                      </span> : <></>}
                  </>

                </div>

                {state?.pkgs && state?.pkgs?.length > 0 && state?.pkgs[0].lockStatus && (state?.pVend?.sellerWeightChangeSts === "V_ACTIVE" || state?.pVend?.sellerWeightChangeSts === "T_ACTIVE") && (
                  <span>This Sku's weight details are accepted by {state?.pVend?.sellerWeightChangeSts === "V_ACTIVE" ? "you" : "Toolsvilla"} on {toLocalDateTime(state?.pVend?.sellerWeightChangeDate)}<OverlayTrigger
                    key="transfer"
                    placement="bottom"
                    overlay={
                      <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                        <p className='fs-8 f-500 order_page_tooltip_1'>{variables.detailsLockedWeight}</p>
                      </Tooltip>
                    }
                  >
                    <i className="bi bi-info-circle ml-1"></i>
                  </OverlayTrigger>
                  </span>
                )}

                {state?.pVend?.sellerWeightChangeSts && 
                   <button className="package_history_btn" onClick={() => setPkgHistoryModalShow(true)}>Check history</button>
                }

                <div className="vnote">
                  {state.pVend.sellerWeightChangeSts === "V_PENDING" ||
                    state.pVend.sellerWeightChangeSts === "V_ACTIVE" ? (
                    <p className="btmNote">
                      <strong>Note - </strong>All the shipments are checked at our courier
                      warehouse and if in case the product weight & dimensions
                      are found different than that given by the logistics
                      company Toolsvilla would debit the seller for the
                      difference. We therefore request you to be careful when
                      entering the weight & dimensions. Thank you!
                    </p>
                  ) : <></>
                  }

                </div>
              </div>
            </Row>
            <div className="bottom-border"></div>
            <div className="pd_desc">
              <div className="pd_long_desc">Description</div>
              {state.pDetail && state.pDetail.description ? (
                <>
                  <div
                    className="pd_description"
                    dangerouslySetInnerHTML={{
                      __html: state.pDetail.description,
                    }}
                  ></div>
                  {state?.pDetail?.descriptionNew && state?.pDetail?.descriptionNew.map((item, index) => {
                    return <><div class="title fs-13 mt-2 bold">{item?.title} : </div><div
                      className="desc fs-13"
                      dangerouslySetInnerHTML={{
                        __html: item.description,
                      }} />
                      {item?.title == 'Specification' && state.pDetail?.specificationNew && state.pDetail?.specificationNew.length > 0 &&
                        state.pDetail?.specificationNew && state.pDetail?.specificationNew.map((item, index) => {
                          return <><div
                            className="desc fs-14"
                          >
                            <ul><li>{item?.type?.name} : {item?.name}{" "}
                              {item?.unit}</li></ul>
                          </div></>
                        })
                      }
                    </>
                  })}
                  {!(state.pDetail?.descriptionNew || []).some(obj => obj.title === "Specifications" || obj.title === "Specification") && state.pDetail?.specificationNew && state.pDetail?.specificationNew != "[]" && state.pDetail?.specificationNew.length > 0 && <>
                    <div>
                      <div class="title fs-14 mb-1 mt-2 bold">Specifications : </div>
                      {state.pDetail?.specificationNew && state.pDetail?.specificationNew != "[]" && state.pDetail?.specificationNew.map((item, index) => {
                        return <><div
                          className="desc fs-14"
                        >
                          <ul><li>{item?.type?.name} : {item?.name}{" "}
                            {item?.unit}</li></ul>
                        </div></>
                      })}
                    </div></>}
                  <div className="bottom-border"></div>
                  <div className="pd_long_desc">
                    Short Description :
                  </div>
                  <div
                    className="pd_description"
                    dangerouslySetInnerHTML={{
                      __html: state.pDetail.shortDescription,
                    }}
                  ></div>
                </>
              ) : (
                <></>
              )}
              {props?.data?.descriptionNew.map((item, index) => {
                return <><div class="title fs-14 mb-1">{item?.title}</div><div
                  className="desc"
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }} /></>
              })}
            </div>
            <div className="bottom-border"></div>
            <div className="pd_desc">
              <div className="pd_long_desc mb-3" id="quesAnsList">Questions & Answers -</div>
              <QuestionAnsList pId={props.match.params.pId} />
            </div>
            <div className="pd_desc">
              <ProductReviews pId={props.match.params.pId} pDetail={state.pDetail} from="productDetails" />
            </div>
          </div>
        </div>

        <Modal
          show={confirmationShow}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Confirmation
            msg={msgConfirmation}
            onHide={() => setconfirmationShow(false)}
            responseconfirmation={responseconfirmationonly}
          />
        </Modal>

        <Modal
          show={confirmationState}
          size="lg"
          className="confirm_modal_det"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <ConfirmationModal
            onHide={confirmationBoxHiding}
            pId={state.pDetail.productName}
            selectedId={selectedId}
            msg={msgConfirmation}
            proresDeact={deactiveReason}
            responseconfirmationFun={responseconfirmation}
            buttonDesign={buttonDesign}
            from="productDetail"
          />
        </Modal>

        {/* Toast */}
        <Toast
          show={showToast}
          className="ToastHome"
          onClose={() => setshowToast(false)}
        >
          <Toast.Header>
            <strong className="me-auto">Message</strong>
          </Toast.Header>
          <Toast.Body>{ToastMsg}</Toast.Body>
        </Toast>

        {/* Off canvas for new price request */}

        <Offcanvas
          show={offcanshow}
          onHide={handleCloseoffcan}
          placement="bottom"
          className="h-40 pd_Offcanvas m-auto "
          backdrop="static"
        >
          <Offcanvas.Header>
            <Offcanvas.Title></Offcanvas.Title>
            <button
              className="pd_my_Modal_close_btn"
              onClick={() => handleCloseoffcan()}
            >
              X
            </button>
          </Offcanvas.Header>
          <Offcanvas.Body className="m-0 p-0">
            <Container className="pd_offcanvas_body">
              <h4 className="text-center">New Price Request</h4>
              <div className="pd_Offcanvas_Grey_Box">
                <p className="theme-col f-600 fs-14 row">

                  <span className="col-11 text-center">
                    <span className="text-black">
                      Current Transfer Price (incl. {state.currGst}% GST)
                    </span>{" "}
                    :
                    <span className="f-600 ms-1">
                      {" "}
                      <i className="fa fa-inr"></i> {state.pPrice}{" "}
                    </span>
                  </span>
                </p>
                {state.lowestPrice !== undefined ? (
                  <p className="pb-0 f-500 text-center">
                    <span className="pd_other_seller_price text-center">
                      {" "}
                      Other seller's price(incl. GST) :{" "}
                      {/*SL-958 Lowest Price */}
                      {/*<i className="fa fa-inr"></i> {state.lowestPriceMargin ? state.lowestPriceMargin : state.lowestPrice}{" "}*/}
                      <i className="fa fa-inr"></i> {state.lowestPrice}{" "}
                    </span>
                  </p>
                ) : (
                  <></>
                )}
              </div>
              <div className="pd_Offcanvas_Action">
                <div className="pd_Offcanvas_Grey_Box">
                  <p className="iscorr_trans_p row">
                    <span className="col-6">

                      Please Enter New Transfer Price :
                    </span>
                    <i
                      className="fa fa-inr pd_input_inr"
                      aria-hidden="true"
                    ></i>
                    <input
                      className="pd_input_price col-2"
                      type="number"
                      onChange={(e) => checkenterprice(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                    ></input>
                    <button
                      className="pd_change_gst_btn col-2"
                      id="sub_newreq"
                      onClick={() => newPriceReq()}
                    >
                      SUBMIT
                    </button>
                  </p>
                </div>
                <div className="pd_Offcanvas_Grey_Box mt-1">
                  <p className="row">
                    <span className="col-6 my-auto">

                      GST :{" "}
                    </span>
                    <Form.Select
                      size="sm"
                      className="pd_Gst_Options col-2"
                      value={gstPercent}
                      onChange={(e) => setGstPercent(e.target.value)}
                    >
                      {gstOptions.length > 0 &&
                        gstOptions.map((item, index) => {
                          return (
                            <option key={index} value={item}>
                              {item} %
                            </option>
                          );
                        })}
                    </Form.Select>{" "}
                    <button
                      className="pd_change_gst_btn col-2"
                      onClick={() => changeGSTFun()}
                    >
                      SUBMIT
                    </button>
                  </p>
                </div>
              </div>
            </Container>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Image showing modal */}

        <Modal
          show={imgmodalShow}
          onHide={imgmodalhandleClose}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            {/* <Modal.Title>Modal title</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <Carousel className="carousel mod_caro m-4" pause="hover">
              {state.images.map((item, index) => {
                let baseImg;
                if (item.image.startsWith("products")) {
                  baseImg = item.image;
                } else if (item.image.startsWith("mob")) {
                  baseImg = item.image;
                } else {
                  let img = item.image.substr("41");
                  baseImg = img;
                }
                return (
                  <Carousel.Item>
                    <img
                      className="d-block slide-size w-100"
                      src={"https://s3.toolsvilla.com/" + baseImg}
                      alt="Product Img"
                    />
                  </Carousel.Item>
                );
              })}

              {/* Videos */}
              {state.videos.length > 0 &&
                state.images.length > 0 &&
                state.videos.map((item, index) => {
                  let vidsrc;
                  if (item.includes("products")) {
                    vidsrc = "https://media.toolsvilla.com/" + item;
                    return (
                      <Carousel.Item key={index} className="video">
                        <video
                          controls
                          className="d-block slide-size w-100"
                          src={vidsrc}
                          alt="Product Img"
                        />
                      </Carousel.Item>
                    );
                  } else {
                    vidsrc = "https://www.youtube.com/embed/" + item;
                    return (
                      <Carousel.Item key={index} className="video">
                        <iframe
                          allowFullScreen
                          className="d-block slide-size w-100"
                          src={vidsrc}
                        ></iframe>
                      </Carousel.Item>
                    );
                  }
                })}
            </Carousel>
          </Modal.Body>
        </Modal>

        {/* Off canvas for verify transfer price */}

        <Offcanvas
          show={offcanshowverify}
          onHide={handleCloseoffcanverify}
          placement="bottom"
          className="h-40 offcan_transfer_price"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="m-auto">
              Verify Transfer Price
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="m-0 p-0">
            {offcanstateverify === "ask" ? (
              <Container>
                <Card className=" mb-2 theme-outline  ">
                  <p className="theme-col px-3 pt-2 pb-0 f-600 fs-14 curr_trans_p text-center">
                    Current Transfer Price (incl. {state.currGst}% GST) :
                    <span className="f-600 fs-13 ms-1 mt-1 text-black ff_pop">
                      {" "}
                      <i className="fa fa-inr"></i> {state.pPrice}{" "}
                    </span>
                  </p>
                  {state.lowestPrice !== undefined && state?.pPrice > state.lowestPrice ? (
                    <p className="px-3 pt-2 pb-0 f-600 fs-11 text-center">
                      <span className="fs-17">
                        <i className="bi bi-exclamation-triangle-fill"></i>
                      </span>
                      <span className="other_seller_price">
                        {" "}
                        Other seller's price(incl. GST) :
                      </span>
                      <span className="f-600 fs-13 ms-1 mt-1 text-primary">
                        {" "}
                        {/*SL-958 Lowest Price */}
                        {/*<i className="fa fa-inr"></i> {state.lowestPriceMargin ? state.lowestPriceMargin : state.lowestPrice}{" "}*/}
                        <i className="fa fa-inr"></i> {state.lowestPrice}{" "}
                      </span>
                    </p>
                  ) : (
                    <></>
                  )}
                  <p className="text-center fs-14 iscorr_trans_p">
                    Is this the correct price{" "}
                    <i class="fa fa-question" aria-hidden="true"></i>
                  </p>

                  <Row className="text-center my-3 ">
                    <div className="col-6 pt-1">
                      <button
                        className="yes-button1 offcan_yes_button"
                        onClick={() => yesVerifyPrice()}
                      >
                        Yes
                      </button>
                    </div>
                    <div className="col-6 pt-1">
                      <button
                        className="yes-button1 offcan_no_button"
                        onClick={() => noVerifyPrice()}
                      >
                        No
                      </button>
                    </div>
                  </Row>
                </Card>
              </Container>
            ) : (
              <Container>
                <Card className=" mb-2 theme-outline  ">
                  <p className="theme-col px-3 pt-2 pb-0 f-600 fs-14 curr_trans_p text-center">
                    Current Transfer Price (incl. {state.currGst}% GST) :
                    <span className="f-600 fs-13 ms-1 mt-1 text-black ff_pop">
                      {" "}
                      <i className="fa fa-inr"></i> {state.pPrice}{" "}
                    </span>
                  </p>
                  <p className="text-center fs-14 iscorr_trans_p">
                    Please Enter New Transfer Price (Incl.{" "}
                    <span className="ff_pop">{state.currGst}</span>% GST) :
                  </p>
                  <div className="text-center">
                    <i className="fa fa-inr me-2"></i>
                    <input
                      type="number"
                      onChange={(e) => setnewPrice(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                      className="inr-input pl-1"
                    ></input>
                  </div>
                  <Row className="text-center my-3 ">
                    <div className="col-12 pt-1">
                      <button
                        className="yes-button1 ff_pop"
                        id="sub_newreq"
                        onClick={() => newPriceReq()}
                      >
                        Submit
                      </button>
                    </div>
                  </Row>
                </Card>
              </Container>
            )}
          </Offcanvas.Body>
        </Offcanvas>

        {/* Off canvas for showing transfer price history */}
        <TPriceHistoryModal data={state.vendToolHistArr} show={offcanshowpriceHist}
          onHide={handleCloseoffcanpriceHist} />
        {/* Product report popup */}
        <div
          id="popupDetail"
          className="overlay"
          style={{ display: isDetailPopupVis, opacity: isDetailPopupVis ? 1 : 0, visibility: isDetailPopupVis ? "visible" : "hidden" }}
        >
          <PopupProductReport

            pid={selectedId}
            SKU={state.pDetail.SKU}
            popupVisibility={setpopupVisibilityDetail}
            categories={state.pDetail.categories}
          />
        </div>

        {/* HSN Modal */}
        <HSNModal
          show={showHSNModal}
          handleCloseModal={handleHSNModalClose}
          productData={{
            id: state.pDetail._id,
            productName: state.pDetail.productName,
            sku: state.pDetail.SKU,
            taxClass: state.pDetail.vendors?.[0]?.taxClass,
            HSN: state?.pDetail?.vendors?.[0]?.HSN
          }}
          from="Product Detail"
          onSave={handleHSNSave}
        />

        {/* l1-2553 */}
        <PackageHistoryModal
          onHide={() => setPkgHistoryModalShow(false)}
          show={pkgHistoryModalShow}
          productId={selectedId}
        />  

      </div >
    );
  }
}
export default ProductDetail;